import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { InstagramIcon, MenuIcon, XIcon } from 'lucide-react';
const NAV_ITEMS = [{
  label: 'Home',
  href: '#home'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md border-b border-slate-100 shadow-[0_1px_20px_rgba(15,23,42,0.05)]' : 'bg-transparent'}`} data-id="element-128" data-mp="1py1kzs5xrm71">
      <nav className="mx-auto max-w-7xl px-5 sm:px-8 h-20 flex items-center justify-between" data-id="element-129" data-mp="9nfyonhmzevj">
        <a href="#home" className="group flex items-center" aria-label="Ally Cleaning Services — Inicio" data-id="element-130" data-mp="emj2y5pslh2g">
          <img src="https://cdn.magicpatterns.com/uploads/qJ4YaQAYSmEGT7DVd9MzLA/Logo_Ally_C.png" alt="Logo circular de Ally Cleaning Services" className="h-14 w-14 rounded-full object-contain transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-131" data-mp="jkkoqyelruhm" />
        </a>

        <ul className="hidden md:flex items-center gap-9" data-id="element-132" data-mp="w5v03cwi2d4">
          {NAV_ITEMS.map(item => <li key={item.label} data-id="element-133" data-mp="5mvzledi616r">
              <a href={item.href} className="text-sm font-medium text-slate-soft hover:text-magenta transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-magenta hover:after:w-full after:transition-all after:duration-300" data-id="element-134" data-mp="5n4h5jkkluoa">
                {item.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden md:flex items-center gap-3" data-id="element-135" data-mp="2wb5dyrhay7ca">
          <a href="https://www.instagram.com/ally.cleaningservices" target="_blank" rel="noreferrer" aria-label="Visit Ally Cleaning Services on Instagram" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-soft transition-colors hover:border-magenta hover:text-magenta focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-magenta" data-id="element-136" data-mp="3b13257f8ex1h">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-137" data-mp="2s8ifw8u1fq6n" />
          </a>
          <a href="sms:+19296509940" className="inline-flex items-center justify-center rounded-full bg-magenta px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-magenta/25 hover:bg-magenta-dark hover:shadow-magenta/30 transition-all" data-id="element-138" data-mp="2n9xgucqivcjs">
            Book Now
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full text-slate hover:bg-slate-100 transition-colors" data-id="element-139" data-mp="f3vjfazxeze6">
          {open ? <XIcon className="h-5 w-5" data-id="element-140" data-mp="swl67hna48cc" /> : <MenuIcon className="h-5 w-5" data-id="element-141" data-mp="xud6ayy2v0rm" />}
        </button>
      </nav>

      <AnimatePresence data-id="element-142" data-mp="xw7kzvir9wn9">
        {open && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25
      }} className="md:hidden overflow-hidden bg-white border-b border-slate-100" data-id="element-143" data-mp="k1x23utfwwp4">
            <ul className="px-5 py-4 space-y-1" data-id="element-144" data-mp="3k2u7dj2kqi15">
              {NAV_ITEMS.map(item => <li key={item.label} data-id="element-145" data-mp="3k56wqhanvuo8">
                  <a href={item.href} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-3 text-base font-medium text-slate-soft hover:bg-slate-50 hover:text-magenta transition-colors" data-id="element-146" data-mp="3f2zi1jyg60i7">
                    {item.label}
                  </a>
                </li>)}
              <li className="pt-2" data-id="element-147" data-mp="1x7o8sq2w1rz">
                <a href="sms:+19296509940" onClick={() => setOpen(false)} className="block rounded-full bg-magenta px-6 py-3 text-center text-sm font-semibold text-white" data-id="element-148" data-mp="1w65e22tmazp">
                  Book Now
                </a>
              </li>
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}